export const BookingPathKeys = {
    basePath: 'basePath',
    startSignInPath: 'startSignInPath',
    selectPatientPath: 'selectPatientPath',
    appointmentInfoPath: 'appointmentInfoPath',
    reviewAndBookPath: 'reviewAndBookPath',
    phoneVerificationPath: 'phoneVerificationPath',
    phoneEntryPath: 'phoneEntryPath',
    appointmentDetailsPath: 'appointmentDetailsPath',
    bookingCompletePath: 'bookingCompletePath',
    legacySyncPath: 'legacySyncPath',
    medicalTeamPath: 'medicalTeamPath',
    patientInfoPath: 'patientInfoPath',
    signUpPath: 'signUpPath',
    createUsernamePath: 'createUsernamePath',
    createPasswordPath: 'createPasswordPath',
    signInPath: 'signInPath',
};

export const basePath = '/booking';

export const paths = {
    [BookingPathKeys.appointmentDetailsPath]: `${basePath}/review`,
    [BookingPathKeys.appointmentInfoPath]: `${basePath}/start`,
    [BookingPathKeys.basePath]: basePath,
    [BookingPathKeys.bookingCompletePath]: `${basePath}/complete`,
    [BookingPathKeys.createUsernamePath]: `${basePath}/createusername`,
    [BookingPathKeys.createPasswordPath]: `${basePath}/createpassword`,
    [BookingPathKeys.reviewAndBookPath]: `${basePath}/reviewandbook`,
    [BookingPathKeys.phoneEntryPath]: `${basePath}/phoneentry`,
    [BookingPathKeys.phoneVerificationPath]: `${basePath}/verify`,
    [BookingPathKeys.selectPatientPath]: `${basePath}/patient`,
    [BookingPathKeys.startSignInPath]: `${basePath}/startsignin`,
    [BookingPathKeys.patientInfoPath]: `${basePath}/patientinfo`,
    [BookingPathKeys.signUpPath]: `${basePath}/signup`,
    [BookingPathKeys.signInPath]: `/signin`,

    // legacy paths left here for ab experiments
    [BookingPathKeys.legacySyncPath]: `${basePath}/sync`,

    // paths outside of booking flow
    [BookingPathKeys.medicalTeamPath]: '/patient/medicalteam',
};

export const CREATE_ACCOUNT_PATHS = [
    paths[BookingPathKeys.patientInfoPath],
    paths[BookingPathKeys.signUpPath],
    paths[BookingPathKeys.createUsernamePath],
    paths[BookingPathKeys.createPasswordPath],
];

export const SHOW_BACK_BUTTON_PATHS = [
    paths[BookingPathKeys.signUpPath],
    paths[BookingPathKeys.createUsernamePath],
    paths[BookingPathKeys.createPasswordPath],
];

export const isCreateAccountPath = (pathname) =>
    CREATE_ACCOUNT_PATHS.some((path) => pathname?.startsWith(path));

export const shouldShowBackButton = (pathname) =>
    SHOW_BACK_BUTTON_PATHS.some((path) => pathname?.startsWith(path));

export const BASE_BOOKING_GA_CATEGORY = 'Booking';

export const BOOKING_GA_CATEGORIES = {
    [BookingPathKeys.basePath]: BASE_BOOKING_GA_CATEGORY,
    [BookingPathKeys.startSignInPath]: 'Booking - Sign In',
    [BookingPathKeys.selectPatientPath]: 'Booking - Select Patient',
    [BookingPathKeys.appointmentInfoPath]: 'Booking - Review',
    [BookingPathKeys.reviewAndBookPath]: 'Booking - Review And Book',
    [BookingPathKeys.phoneVerificationPath]: 'Booking - Phone Ver',
    [BookingPathKeys.phoneEntryPath]: BASE_BOOKING_GA_CATEGORY,
    [BookingPathKeys.appointmentDetailsPath]: 'Booking - Details',
    [BookingPathKeys.bookingCompletePath]: 'Booking - Booking Complete',
    [BookingPathKeys.patientInfoPath]: 'Booking - Patient Info',
    [BookingPathKeys.signUpPath]: 'Booking - Sign Up',
    [BookingPathKeys.createUsernamePath]: 'Booking - Create Username',
    [BookingPathKeys.createPasswordPath]: 'Booking - Create Password',
    [BookingPathKeys.signInPath]: 'Sign In',
    [BookingPathKeys.legacySyncPath]: '',
    [BookingPathKeys.medicalTeamPath]: '',
};

export const getMetricsCategoryFromPathname = (pathname) => {
    const path = CREATE_ACCOUNT_PATHS.find((p) => pathname.includes(p));

    const pathKey = Object.entries(paths).find(
        (keyValPair) => keyValPair[1] === path
    )[0];

    return BOOKING_GA_CATEGORIES[pathKey];
};
